import { Stack } from "@mui/material";
import { isEmpty } from "lodash";

import { type VisitOccurrenceData } from "../types";
import { VisitOccurrencesCard } from "./Card";
import { VisitOccurrencesEmptyState } from "./EmptyState";

interface VisitOccurrencesListProps {
  visitOccurrences: VisitOccurrenceData[];
}

export function VisitOccurrencesList(props: VisitOccurrencesListProps) {
  const { visitOccurrences } = props;

  if (isEmpty(visitOccurrences)) {
    return <VisitOccurrencesEmptyState />;
  }

  return (
    <Stack width="100%" spacing={5}>
      {visitOccurrences.map((visitOccurrence) => (
        <VisitOccurrencesCard key={visitOccurrence.id} visitOccurrence={visitOccurrence} />
      ))}
    </Stack>
  );
}
